import React from "react";

export const SearchIcon = ({ onClick }) => {
    return <svg className="menu-middle__search-icon"  width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="13" cy="9" r="8.4" stroke="black" strokeWidth="1.2"/>
        <line x1="7.42426" y1="15.4243" x2="0.424264" y2="22.4243" stroke="black" strokeWidth="1.2"/>
    </svg>;
};